/* import __COLOCATED_TEMPLATE__ from './emoji-inserter.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();